module.exports = __webpack_public_path__ + "static/media/jumbled-words-penguin.80ae6306.svg";